
import { faArrowRightToBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { limpiarToken } from "../../../reducer/tokenReducer/token.reducer";
import { AlertaConfirmar } from "../../../helpers/alerts/alertaConfirmacion";

function CerrarSesion() {
    const dispatch = useDispatch();
    const salir = async () => {
        const result = await AlertaConfirmar('Salir', '¿Desea salir del sistema?');
        if (result) {
            dispatch(limpiarToken());
        }
    };
    return <a onClick={salir} className='flex text-sm'>
        <FontAwesomeIcon
            icon={faArrowRightToBracket}
        />
        <p className=' text-DarkText font-semibold'>Salir</p>
    </a>;
};

export default CerrarSesion;
